import { ERichMenuAreaActionType } from './enum'

export type ERichMessageAreaActionType = Exclude<
  ERichMenuAreaActionType,
  ERichMenuAreaActionType.Survey
>

export enum ERichMessageTemplateCategory {
  Square = 'square',
  Landscape = 'landscape',
  Portrait = 'portrait',
  Custom = 'custom',
}

export type TRichMessageBounds = {
  x: number
  y: number
  width: number
  height: number
}

export type TRichMessageTemplate = {
  id: string
  label: string
  category: ERichMessageTemplateCategory
  size: { width: number; height: number }
  areaKeys: string[]
  bounds: TRichMessageBounds[]
  sortOrder: number
}

export type TRichMessageAreaAction = {
  type: ERichMessageAreaActionType
  label?: string
  uri?: string
  text?: string
}

export type TRichMessageAreaPayload = {
  key: string
  bounds: TRichMessageBounds
  action: TRichMessageAreaAction
}

export type TRichMessageImagemapPayload = {
  altText: string
  templateId: string
  imageUrl: string
  imagemapBaseUrl?: string
  baseSize: { width: number; height: number }
  areas: TRichMessageAreaPayload[]
}
